import { useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { getStorageJSON } from "../../utils/helpers";

export default function Partner() {
  const currentUser = getStorageJSON("user", null);
  const [partnerType, setPartnerType] = useState("restaurant");
  const [name, setName] = useState("");
  const [email, setEmail] = useState(currentUser?.email || "");
  const [phone, setPhone] = useState(currentUser?.phone || "");
  const [business, setBusinessName] = useState("");
  const [area, setArea] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!name.trim() || !email.trim() || !phone.trim() || !business.trim() || !area.trim()) {
      setStatus("error:Please fill all fields");
      return;
    }

    // Save to localStorage as partnership inquiry
    const inquiries = JSON.parse(localStorage.getItem("partnershipInquiries") || "[]");
    inquiries.push({
      id: Date.now(),
      partnerType,
      name,
      email,
      phone,
      businessName: business,
      area,
      createdAt: new Date().toISOString(),
    });
    localStorage.setItem("partnershipInquiries", JSON.stringify(inquiries));

    // Simulate email
    setTimeout(() => {
      setStatus("success:Thank you! We'll contact you within 24 hours.");
      setName("");
      setBusinessName("");
      setArea("");
    }, 800);

    setTimeout(() => setStatus(""), 5000);
  };

  const areas = ["Malad", "Kandivali", "Borivali", "Dahisar", "Other"];

  return (
    <div className="home">
      <Navbar />

      <div className="customer-page">
        <div className="customer-page-header">
          <h2>Partner With Us</h2>
          <p>Expand your reach and grow your business with Shreeji Surti Swad</p>
        </div>

        <section className="customer-card settings-section">
          <h3>Why Partner With Shreeji Surti Swad?</h3>
          <div className="partner-benefits">
            <article className="feature-card">
              <h4>📈 Grow Your Business</h4>
              <p>Reach hundreds of customers in your area</p>
            </article>
            <article className="feature-card">
              <h4>📱 Easy Integration</h4>
              <p>Simple onboarding process and dedicated support</p>
            </article>
            <article className="feature-card">
              <h4>💰 Competitive Commissions</h4>
              <p>Fair pricing to maximize your profits</p>
            </article>
            <article className="feature-card">
              <h4>📍 Local Focus</h4>
              <p>We celebrate local businesses and authentic cuisine</p>
            </article>
          </div>
        </section>

        <section className="customer-card settings-section">
          <h3>Our Partners</h3>
          <p>
            We work with restaurants, cloud kitchens, food entrepreneurs, and delivery professionals. 
            Whether you're an established restaurant or just starting out, we have a partnership model for you.
          </p>
        </section>

        <section className="customer-card settings-section">
          <h3>Get In Touch</h3>
          <form onSubmit={handleSubmit} className="settings-form">
            {status && (
              <div className={`form-message ${status.split(":")[0]}`}>
                {status.split(":")[1]}
              </div>
            )}

            <div className="form-group">
              <label>Partner Type</label>
              <select value={partnerType} onChange={(e) => setPartnerType(e.target.value)}>
                <option value="restaurant">Restaurant/Cloud Kitchen</option>
                <option value="delivery">Delivery Partner</option>
                <option value="entrepreneur">Food Entrepreneur</option>
                <option value="advertiser">Advertiser/Sponsor</option>
              </select>
            </div>

            <div className="form-group">
              <label>Your Name</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
              />
            </div>

            <div className="form-group">
              <label>Business Name</label>
              <input
                type="text"
                value={business}
                onChange={(e) => setBusinessName(e.target.value)}
                placeholder="Your restaurant/business name"
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
              />
            </div>

            <div className="form-group">
              <label>Phone Number</label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+91-XXXXXXXXXX"
              />
            </div>

            <div className="form-group">
              <label>Service Area</label>
              <select value={area} onChange={(e) => setArea(e.target.value)}>
                <option value="">Select your area</option>
                {areas.map((ar) => (
                  <option key={ar} value={ar}>
                    {ar}
                  </option>
                ))}
              </select>
            </div>

            <button type="submit" className="primary-action">
              Submit Application
            </button>
          </form>
        </section>

        <section className="customer-card settings-section">
          <h3>Quick Contact</h3>
          <div className="contact-info">
            <p>
              <strong>📧 Email:</strong> shreejisurtiswad@gmail.com<br/>
              <strong>📱 Phone:</strong> +91-7977788566<br/>
              <strong>⏰ Response Time:</strong> Within 24-48 hours
            </p>
          </div>
          <div className="page-actions" style={{ marginTop: "1rem" }}>
            <button className="primary-action" onClick={() => window.location.href = "mailto:shreejisurtiswad@gmail.com"}>
              Email Us Now
            </button>
            <button className="secondary-action" onClick={() => window.location.href = "https://wa.me/917977788566"}>
              WhatsApp Us
            </button>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
}
